"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInputFieldStyles = void 0;
var core_1 = require("@material-ui/core");
var commons_1 = require("../../../style/commons");
exports.useInputFieldStyles = (0, core_1.makeStyles)(function (isTable) {
    if (isTable === void 0) { isTable = false; }
    return ({
        inputLabel: {
            padding: 0,
            zIndex: 'auto',
            position: 'relative',
            transform: 'translate(0,0)',
            color: commons_1.darkSecondary,
            fontSize: 14,
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: '17px',
            letterSpacing: 'normal',
            marginBottom: 4,
            '&$inputLabelShrink': {
                transform: 'translate(0,0) scale(1)',
            },
            '&$inputLabelFocused': {
                color: commons_1.darkSecondary,
            },
        },
        inputLabelShrink: {},
        inputLabelFocused: {},
        inputLabelError: {
            color: commons_1.darkSecondary,
        },
        inputLabelRequiredDecorator: {
            position: 'relative',
            left: -1,
        },
        inputBase: {
            outline: "1px solid ".concat(commons_1.brandPrimaryLight),
            borderRadius: 4,
            backgroundColor: commons_1.secondaryHover,
            height: '40px',
            '&$inputBaseFocused': {
                outline: "2px solid ".concat(commons_1.brandPrimaryExtraDark, " !important"),
                backgroundColor: commons_1.lightSecondary,
                '&:hover': {
                    outline: "2px solid ".concat(commons_1.brandPrimaryExtraDark),
                },
            },
            '&$inputBaseDisabled': {
                opacity: 0.4,
            },
            '&$inputBaseDisabled:hover': {
                borderColor: commons_1.brandPrimaryDark,
            },
            '&:hover': {
                outline: "1px solid ".concat(commons_1.primaryColor),
            },
        },
        inputBaseFocused: {
            outline: "2px solid ".concat(commons_1.brandPrimaryExtraDark, " !important"),
        },
        inputBaseDisabled: {},
        inputBaseError: {
            borderColor: commons_1.mediumDanger,
        },
        startInputAdornment: {
            marginLeft: 12,
            marginRight: '0 !important',
        },
        input: {
            borderRadius: 4,
            color: commons_1.darkSecondary,
            fontSize: 16,
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 'normal',
            letterSpacing: 'normal',
            height: 38,
            padding: '0 12px',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            '&::placeholder': {
                fontStyle: 'normal',
                fontWeight: 'normal',
                color: commons_1.textInputColor,
                opacity: 1,
            },
            '&:-ms-input-placeholder': {
                fontStyle: 'normal',
                color: commons_1.textInputColor,
                opacity: 1,
            },
            '& + fieldset': {
                display: 'none',
            },
            '&:-webkit-autofill': {
                boxShadow: '0 0 0px 1000px transparent inset',
                backgroundColor: 'inherit',
                transition: 'background-color 5000s ease-in-out 0s',
            },
        },
        errorHelperText: {
            margin: 0,
            fontSize: 12,
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 'normal',
            letterSpacing: 'normal',
            color: commons_1.mediumRed,
        },
    });
});
